export const getShowCount = width => {
  if (width <= 1024) {
    return 9
  } else return 12
}
